var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReliantLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1187.07 682.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0d8cff;\n      }\n\n      .cls-2 {\n        fill: #6e39ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.54,73.53l-98.13,98.13c-33.34-22.45-72.48-34.48-113.5-34.48-54.46,0-105.63,21.22-144.18,59.72-31.87,31.92-51.86,72.48-57.76,116.47H0c6.4-80.67,40.88-155.62,98.77-213.51C163.21,35.49,248.81,0,339.9,0c77.78,0,151.59,25.88,211.63,73.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M822.2,341.05l-241.13,241.13c-9.47,9.47-19.34,18.25-29.59,26.29-61.73,48.98-136.68,73.44-211.59,73.44-87.34,0-174.64-33.24-241.13-99.73C40.88,524.33,6.4,449.38,0,368.71h138.01c5.85,43.95,25.84,84.55,57.71,116.47,38.55,38.5,89.72,59.68,144.18,59.72,41.02,0,80.16-12.03,113.54-34.48,10.88-7.32,21.13-15.73,30.64-25.24l241.13-241.13,5.76,5.72,91.23,91.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1187.07,368.71c-6.36,80.67-40.88,155.62-98.82,213.46-64.34,64.43-150.04,99.87-241.08,99.92-77.78,0-151.59-25.88-211.63-73.58l98.18-98.13c79.16,53.14,187.63,44.72,257.59-25.2,31.92-31.92,51.95-72.53,57.85-116.47h137.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1187.07,313.38h-137.92c-5.9-43.99-25.93-84.55-57.85-116.47-38.5-38.5-89.67-59.72-144.14-59.72-41.02,0-80.21,12.03-113.5,34.48-10.88,7.32-21.13,15.73-30.68,25.24l-109.43,109.47-34.66,34.66-96.99,96.99-5.76-5.76-91.27-91.23,91.27-91.23,40.42-40.42,96.99-97.04,12.48-12.48c9.42-9.42,19.21-18.2,29.5-26.34C695.58,25.88,769.39,0,847.17,0c91.05,0,176.74,35.49,241.17,99.87,57.85,57.89,92.37,132.84,98.73,213.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliantLogoColor);
export default __webpack_public_path__ + "static/media/reliant-logo-color.fceb128001b75aece8a7e7ba6ae547b3.svg";
export { ForwardRef as ReactComponent };